const WinlosesTypes = {
    FETCH_START:    '[HOSTESS] FETCH START',
    FETCH_SUCCESS:  '[HOSTESS] FETCH SUCCESS',
    FETCH_FAILURE:  '[HOSTESS] FETCH FAILURE'
};

export default WinlosesTypes;